/**
 * "Prices for Nigeria · change" — shown above public plan prices. The
 * country is detected (lib/visitor-locale); visitors can pick another, and
 * the choice is remembered on this device.
 */
import React from "react";
import { Globe } from "lucide-react";
import useAuthStore from "@/stores/authStore";
import { COUNTRIES } from "@/lib/currency";
import { pickCountry, useVisitorLocale } from "@/lib/visitor-locale";

export const PricesFor: React.FC<{ className?: string }> = ({ className = "" }) => {
  const signedIn = useAuthStore((s) => s.isAuthenticated);
  const v = useVisitorLocale(undefined, !signedIn);
  if (signedIn) return null;
  const current = v.data?.country || "";
  return (
    <div className={`flex items-center gap-1.5 text-xs text-gray-500 ${className}`}>
      <Globe className="h-3.5 w-3.5" aria-hidden />
      <label htmlFor="prices-for">Prices for</label>
      <select
        id="prices-for"
        value={current}
        onChange={(e) => {
          pickCountry(e.target.value || null);
        }}
        className="rounded border border-gray-200 bg-white px-1.5 py-0.5 text-xs text-gray-700"
      >
        {!current && <option value="">Choose your country</option>}
        {COUNTRIES.map((c) => (
          <option key={c.code} value={c.code}>
            {c.name} ({c.currency})
          </option>
        ))}
      </select>
    </div>
  );
};

export default PricesFor;
